import { updateObject } from '../shared/utility';
import { LAST_MATCHES_START, LAST_MATCHES_SUCCESS, LAST_MATCHES_FAIL } from '../constants/actionTypes';

const initialState={
    message:null,
    error:null,
    loading:false,
    matches:null,
}

const matchesStart=(state,action)=>{
    return updateObject(state,{message:null,error:null,loading:true});
}

const matchesSuccess=(state,action)=>{
    console.log(action.payload)
    return updateObject(state,{message:'matches success',error:null,loading:false,matches:action.payload});
}

const matchesFail=(state,action)=>{
    return updateObject(state,{message:null,error:null,loading:false,matches:null});
}

const matchesReducer=(state=initialState,action)=>{
    switch(action.type)
    {
        case LAST_MATCHES_START:
            return matchesStart(state,action);
        case LAST_MATCHES_SUCCESS:
            return matchesSuccess(state,action);
        case LAST_MATCHES_FAIL:
            return matchesFail(state,action);
        default:
            return state;
    }
}

export default matchesReducer;